import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import utils from '../../utils'
import { useAuth } from '../../context/UserContext'

function NavBar() {
    const { isAuth, user } = useAuth()
    const navigate = useNavigate()
    return (
        <div className='border-b border-slate-200 sticky top-0 bg-base-100 z-10 mb-4 bg-opacity-95 lg:bg-opacity-90'>
            <div className="navbar p-1 nav-top container mx-auto ">
                <div className="navbar-start gap-4">
                    <Link to='/' className="btn btn-ghost text-lg lg:text-xl font-extrabold tracking-tight lg:hidden bg-primary/10 hover:bg-primary/20 transition-colors rounded-xl">
                        <h1 className='text-xl font-bold tracking-wide'>Health<span className='text-primary'>Connect</span></h1>
                    </Link>

                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal px-1 gap-5">
                        {!isAuth && (
                            <>
                                <Link to={'/about#for-nurses'} className="text-sm font-semibold text-text-secondary hover:text-primary transition-colors" >For Nurses</Link>
                                <Link to={'/about#matching'} className="text-sm font-semibold text-text-secondary hover:text-primary transition-colors" >How it Works</Link>
                                <Link to={'/contact'} className="text-sm font-semibold text-text-secondary hover:text-primary transition-colors" >Contact Us</Link>
                            </>
                        )}
                    </ul>
                </div>
                <div className="navbar-end gap-4">
                    {!isAuth && (
                        <ul className="menu menu-horizontal">
                            <button
                                onClick={() => {
                                    navigate('/#patient-process')
                                }}
                                className='btn btn-primary rounded-xl hidden lg:block'>Get Started</button>
                        </ul>
                    )}
                    {isAuth && (
                        <Link to={'/auth/settings'}>
                            <div className="hidden md:avatar placeholder">
                                <div className="bg-neutral text-white rounded-full w-11">
                                    <span className="text-lg">{utils.makeProfileLetter(user)}</span>
                                </div>
                            </div>
                        </Link>
                    )}
                    <label htmlFor="nav-drawer">
                        <div
                            aria-label="Open menu"
                            className="btn btn-ghost btn-circle lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
}

export default NavBar